module.exports = __webpack_public_path__ + "img/9.4535c82a.jpg";